import {useGetNegotiationDetailQuery} from "../redux/api/negotiationsApiSlice";
import {useParams} from "react-router-dom";
import {skipToken} from "@reduxjs/toolkit/dist/query";
import {useSelector} from "react-redux";
import {selectUser} from "../redux/features/userSlice";
import {canUseAIAgent} from "./permission";

export const useAIFunctionality = (): boolean => {
    const {id} = useParams()
    const user = useSelector(selectUser);

    const {data: negotiation} = useGetNegotiationDetailQuery(id ?? skipToken);

    if (!negotiation || !user) {
        return false;
    }

    const hasPermission = canUseAIAgent(user?.usertypes?.map(el => el.code))
    const isAILobEnabled = negotiation.lob?.ai_enabled === true;
    const hasNegotiationAnalysis = negotiation.negotiation_analysis !== null;

    return hasPermission && isAILobEnabled && hasNegotiationAnalysis;
};
